/* lust-us-final2706v2.js — consolidated, single checkout handler
   Reads image URLs from window.lustF2706Config injected by section
   2026-06-28
*/
(function () {
  'use strict';

  var ROOT = '.lust-final2706-single';
  var root = document.querySelector(ROOT);
  if (!root) return;

  var cfg = window.lustF2706Config || {};

  /* ── 1. HERO CAROUSEL ── */
  (function () {
    var img = root.querySelector('#heroImg');
    if (!img) return;
    var imgs = cfg.heroImages || [];
    if (!imgs.length) return;

    var dotWrap = root.querySelector('.carousel-dots');
    var dots;
    if (dotWrap) {
      dotWrap.innerHTML = imgs.map(function (_, i) {
        return '<span' + (i === 0 ? ' class="active"' : '') + '></span>';
      }).join('');
      dots = root.querySelectorAll('.carousel-dots span');
    } else {
      dots = [];
    }

    imgs.forEach(function (src) { var im = new Image(); im.src = src; });

    var cur = 0, busy = false;
    img.style.transition = 'opacity .22s ease';

    function setDot(i) {
      [].forEach.call(dots, function (d, idx) { d.classList.toggle('active', idx === i); });
    }

    function go(dir) {
      if (busy) return;
      busy = true;
      cur = (cur + dir + imgs.length) % imgs.length;
      setDot(cur);
      img.style.opacity = '0';
      setTimeout(function () {
        img.onload = function () {
          img.style.opacity = '1';
          setTimeout(function () { busy = false; }, 230);
          img.onload = null;
        };
        img.src = imgs[cur];
        if (img.complete) { img.style.opacity = '1'; setTimeout(function () { busy = false; }, 230); }
      }, 90);
    }

    var prev = root.querySelector('.cs-prev');
    var nxt = root.querySelector('.cs-next');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (nxt) nxt.addEventListener('click', function () { go(1); });
    setDot(0);
  }());

  /* ── 2. PACK SELECTOR + PRICE DISPLAY ── */
  var opts = [].slice.call(root.querySelectorAll('.pack-opt'));
  var qtyInput = root.querySelector('#lustFinal2706Qty');
  var priceNow = root.querySelector('#priceNow');
  var priceWas = root.querySelector('#priceWas');
  var perNote = root.querySelector('#perNote');
  var shipBadge = root.querySelector('#shipBadge');
  var stickyLbl = root.querySelector('#stickyLabel');
  var altCta = root.querySelector('#altCta');

  function qtyFrom(opt) {
    var m = (opt.dataset.href || '').match(/:(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function packLabel(opt) {
    var t = ((opt.querySelector('.pack-info b') || {}).textContent || '').replace(/\s+/g, ' ').trim();
    return t + ' — ' + (opt.dataset.price || '');
  }

  function renderPack(opt) {
    if (!opt) return;
    opts.forEach(function (o) { o.classList.remove('sel'); o.setAttribute('aria-checked', 'false'); });
    opt.classList.add('sel');
    opt.setAttribute('aria-checked', 'true');
    var qty = qtyFrom(opt);
    if (qtyInput) qtyInput.value = qty;
    if (priceNow) priceNow.textContent = opt.dataset.price || '';
    if (priceWas) priceWas.textContent = opt.dataset.was || '';
    if (perNote) perNote.textContent = opt.dataset.per || '';
    if (shipBadge) shipBadge.textContent = opt.dataset.badge || '';
    if (stickyLbl) stickyLbl.textContent = packLabel(opt);
  }

  opts.forEach(function (opt) {
    opt.setAttribute('role', 'radio');
    opt.tabIndex = 0;
    opt.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); renderPack(opt); });
    opt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); renderPack(opt); }
    });
  });

  if (altCta) {
    altCta.addEventListener('click', function (e) {
      e.preventDefault();
      if (opts[0]) renderPack(opts[0]);
    });
  }

  renderPack(root.querySelector('.pack-opt.sel') || opts[1] || opts[0]);

  /* ── 3. CHECKOUT HANDLER — single, BFC-safe ── */
  function selectedQty() {
    var sel = root.querySelector('.pack-opt.sel');
    if (sel) {
      var m = (sel.dataset.href || '').match(/:(\d+)/);
      if (m) return parseInt(m[1], 10) || 1;
    }
    return parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
  }

  function armCheckout() {
    ['#mainCta'].forEach(function (sel) {
      var btn = root.querySelector(sel);
      if (!btn || btn.dataset.checkoutArmed === '1') return;
      btn.dataset.checkoutArmed = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantInput = root.querySelector('#lustFinal2706ProductForm input[name="id"]');
        var id = variantInput && variantInput.value;
        var qty = selectedQty();
        if (qtyInput) qtyInput.value = qty;
        btn.textContent = 'CHECKING OUT…';
        if (!id) { window.location.assign('/checkout'); return; }
        window.location.assign('/cart/clear?return_to=' + encodeURIComponent('/cart/' + id + ':' + qty + '?checkout'));
      }, true);
    });
  }

  armCheckout();

  /* Re-arm after bfcache restore so button isn't stuck in loading state */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      ['#mainCta'].forEach(function (sel) {
        var btn = root.querySelector(sel);
        if (btn) {
          btn.textContent = 'BUY NOW';
          delete btn.dataset.checkoutArmed;
        }
      });
      armCheckout();
    }
  });

  /* ── 4. NATIVE SMOOTH SCROLL TO BUY PANEL ── */
  var buyPanel = root.querySelector('#buy-panel');
  function scrollToBuyPanel() {
    if (!buyPanel) return;
    buyPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (buyPanel) {
    root.querySelectorAll('a[href="#buy-panel"], a[href="#buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToBuyPanel();
      }, true);
    });
  }

  /* Sticky CTA scrolls back to buy panel / pack cards; it does not checkout directly. */
  var stickyCta = root.querySelector('#stickyCta');
  if (stickyCta && buyPanel && stickyCta.dataset.scrollArmed !== '1') {
    stickyCta.dataset.scrollArmed = '1';
    stickyCta.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToBuyPanel();
    }, true);
  }

  /* Robust sticky fallback: if tap lands on button children/near CTA area, one tap still scrolls. */
  var stickyWrap = root.querySelector('.sticky');
  if (stickyWrap && buyPanel && stickyWrap.dataset.stickyDelegate !== '1') {
    stickyWrap.dataset.stickyDelegate = '1';
    stickyWrap.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('#stickyCta');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      scrollToBuyPanel();
    }, true);
    stickyWrap.addEventListener('touchend', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('#stickyCta');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      scrollToBuyPanel();
    }, { passive: false, capture: true });
  }


  /* ── 5. BUY PANEL ACCORDIONS — one open at a time ── */
  root.querySelectorAll('.bp-accordions details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      root.querySelectorAll('.bp-accordions details').forEach(function (other) {
        if (other !== d) other.removeAttribute('open');
      });
    });
  });

  /* ── 6. COUNT-UP STATS ── */
  var statNums = [].slice.call(root.querySelectorAll('.count-up'));
  var statsFired = false;

  function animateStats() {
    if (statsFired) return;
    statsFired = true;
    statNums.forEach(function (el) {
      var target = parseFloat(el.dataset.target || '0');
      var suffix = el.dataset.suffix || '';
      var dec = parseInt(el.dataset.decimal || '0', 10);
      var start = null, dur = 1300;
      function step(ts) {
        start = start || ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var v = target * eased;
        el.textContent = (dec ? v.toFixed(dec) : Math.floor(v)) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (dec ? target.toFixed(dec) : target) + suffix;
      }
      requestAnimationFrame(step);
    });
  }

  var statsGrid = root.querySelector('.nums');
  function checkStats() {
    if (!statsGrid || statsFired) return;
    var r = statsGrid.getBoundingClientRect();
    if (r.top < window.innerHeight * .68 && r.bottom > 0) animateStats();
  }
  window.addEventListener('scroll', checkStats, { passive: true });
  window.addEventListener('resize', checkStats);
  setTimeout(checkStats, 250);

  /* ── 7. TIMELINE CARDS — static raised cards, no scroll glow work ── */
  [].slice.call(root.querySelectorAll('.drum-item')).forEach(function (card) { card.classList.add('visible'); });



  /* ── 7b. TIME PILL GRADIENT PROGRESS — only 0/15/30/2->4 tags ── */
  (function () {
    var items = [].slice.call(root.querySelectorAll('.drum-item'));
    if (!items.length) return;
    var ticking = false;
    function updateTimePills() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;
      items.forEach(function (item) {
        var badge = item.querySelector('.di-time-badge');
        if (!badge) return;
        var r = item.getBoundingClientRect();
        var start = vh * 0.88;
        var end = vh * 0.28;
        var p = (start - r.top) / (start - end);
        p = Math.max(0, Math.min(1, p));
        badge.style.setProperty('--time-progress', Math.round(p * 100) + '%');
      });
    }
    function requestUpdate() { if (!ticking) { ticking = true; requestAnimationFrame(updateTimePills); } }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    setTimeout(updateTimePills, 120);
  }());

  /* ── 8. PRESS STAT REVEAL ── */
  [].slice.call(root.querySelectorAll('.press-stat-row')).forEach(function (row) {
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        var v = card.querySelector('video');
        var b = card.querySelector('.f2706-sound');
        if (v) { loadVideo(v); stopAndMute(v, b); }
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { row.classList.add('visible'); io.disconnect(); }
    }, { threshold: 0.45, rootMargin: '0px 0px -60px 0px' });
    io.observe(row);
  });

  /* ── 9. REVIEW CARDS — infinite auto-scroll ── */
  (function () {
    var el = root.querySelector('.rev-scroll');
    if (!el || el.dataset.mobileAutoplay) return;
    el.dataset.mobileAutoplay = '1';

    var origCards = [].slice.call(el.querySelectorAll('.rv'));
    origCards.forEach(function (c) { el.appendChild(c.cloneNode(true)); });

    var paused = false;
    el.style.scrollSnapType = 'none';
    el.scrollLeft = 0;

    function tick() {
      if (!paused) {
        el.scrollLeft += 0.7;
        var half = el.scrollWidth / 2;
        if (el.scrollLeft >= half) el.scrollLeft -= half;
      }
      requestAnimationFrame(tick);
    }

    el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    el.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 900); });
    el.addEventListener('mousedown', function () { paused = true; });
    el.addEventListener('mouseup', function () { paused = false; });
    el.addEventListener('mouseleave', function () { paused = false; });

    requestAnimationFrame(tick);
  }());

  /* ── 10. VIDEO — no popup, autoplay when >50% visible, mute+pause after pass ── */
  (function () {
    var cards = [].slice.call(root.querySelectorAll('.f2706-video-card'));
    if (!cards.length) return;

    function loadVideo(v) {
      if (v && !v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); }
    }

    function playWithSound(v, btn) {
      if (!v) return;
      loadVideo(v);
      v.muted = false;
      v.volume = 1;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          /* Browsers may block unmuted autoplay before user gesture; keep UX alive muted. */
          v.muted = true;
          try { v.play(); } catch (_) {}
        });
      }
      if (btn) btn.classList.toggle('on', !v.muted);
    }

    function stopAndMute(v, btn) {
      if (!v) return;
      v.pause();
      v.muted = true;
      if (btn) btn.classList.remove('on');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var card = e.target;
        var v = card.querySelector('video');
        var b = card.querySelector('.f2706-sound');
        if (!v) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          playWithSound(v, b);
        } else {
          stopAndMute(v, b);
        }
      });
    }, { threshold: [0, 0.5, 0.75, 1] });

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      var b = card.querySelector('.f2706-sound');
      if (!v) return;
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      if (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          loadVideo(v);
          v.muted = !v.muted;
          b.classList.toggle('on', !v.muted);
          try { v.play(); } catch (_) {}
        });
      }
      card.addEventListener('click', function (e) {
        if (e.target && e.target.closest('.f2706-sound')) return;
        e.preventDefault();
        playWithSound(v, b);
      });
      io.observe(card);
    });
  }());

}());
